const FIELD_LABELS = {
  email: 'E-Mail-Adresse', first_name: 'Vorname', last_name: 'Nachname', name: 'Name',
  phone: 'Telefonnummer', password: 'Passwort', password_confirmation: 'Passwort wiederholen',
  street: 'Straße und Hausnummer', address: 'Adresse', postal_code: 'Postleitzahl', city: 'Ort', country: 'Land',
  location_id: 'Standort', service_id: 'Behandlung', staff_id: 'Mitarbeiter', client_id: 'Patient',
  birthdate: 'Geburtsdatum', start_time: 'Beginn', end_time: 'Ende', quantity: 'Menge',
  amount: 'Betrag', price: 'Preis', title: 'Titel', subject: 'Betreff', message: 'Nachricht',
  legal_company_name: 'Unternehmensname', billing_street: 'Rechnungsadresse', billing_postal_code: 'Postleitzahl',
  billing_city: 'Ort', recipient: 'Empfänger', recipient_email: 'E-Mail-Adresse des Empfängers',
  due_date: 'Fälligkeitsdatum', issue_date: 'Rechnungsdatum', code: 'Bestätigungscode',
};
export function validationFieldLabel(field) { return FIELD_LABELS[String(field || '').split('.').at(-1)] || 'Angabe'; }
export function humanizeValidationText(text) {
  return String(text || '').replace(/\b(?:body|query|path)\.([\w.[\]-]+):\s*/g, (_,field) => `${validationFieldLabel(field)}: `);
}
